import React,{useCallback,useEffect,useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faUsers, faClock, faPlay, faRobot, faBrain, faChartLine, faCode, faProjectDiagram, faCloud, faCheckCircle, faDatabase, faServer, faLaptopCode, faCertificate, faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub, faTwitter, faMedium } from '@fortawesome/free-brands-svg-icons';
import './HeroSection.css';
 
const ProjectManager = () => {
   const [showModal, setShowModal] = useState(false);
        const [formCourseName, setFormCourseName] = useState('Project Management');
        const [formData, setFormData] = useState({
          fullName: '',
          mobileNumber: '',
          email: '',
        });
      
        const openModal = () => setShowModal(true);
        const closeModal = useCallback(() => {
          setShowModal(false);
          setFormData({ fullName: '', mobileNumber: '', email: '' });
        }, []);
      
        useEffect(() => {
          const handleEsc = (e) => {
            if (e.key === 'Escape') closeModal();
          };
          window.addEventListener('keydown', handleEsc);
          return () => window.removeEventListener('keydown', handleEsc);
        }, [closeModal]);
      
        const handleInputChange = (e) => {
          const { name, value } = e.target;
          if (name === 'mobileNumber') {
            const digitsOnly = value.replace(/\D/g, '');
            if (digitsOnly.length <= 10) {
              setFormData(prev => ({ ...prev, [name]: digitsOnly }));
            }
          } else {
            setFormData(prev => ({ ...prev, [name]: value }));
          }
        };
      
        const handleSubmit = async (e) => {
          e.preventDefault();
          const { fullName, mobileNumber, email } = formData;
      
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
          if (!fullName || !emailRegex.test(email) || mobileNumber.length !== 10) {
            alert('Please fill in valid details.');
            return;
          }
      
          try {
            const response = await fetch('https://api.dikshasea.in/api/enrollments', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ...formData, course: formCourseName }),
            });
      
            const result = await response.json();
            if (response.ok) {
              alert('Enrollment successful!');
              closeModal();
            } else {
              alert(result.message || 'Submission failed');
            }
          } catch (err) {
            console.error(err);
            alert('Error submitting form');
          }
        };
      
  return (
    <>
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 className="hero-title">
                Master <span className="hero-highlight">Project Management</span>
              </h1>
              <p className="hero-subtitle">
                Develop essential project management skills with our comprehensive course designed for aspiring and experienced managers.
                Learn industry-standard methodologies and gain practical experience through real-world case studies.
              </p>
             
              <div className="course-meta">
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faStar} />
                  </div>
                  <div>
                    <div className="fw-bold">4.8/5.0</div>
                    <small className="text-muted">(1,850 reviews)</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faUsers} />
                  </div>
                  <div>
                    <div className="fw-bold">6,200+</div>
                    <small className="text-muted">Professionals</small>
                  </div>
                </div>
                <div className="meta-item">
                  <div className="meta-icon">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <div className="fw-bold">40 hours</div>
                    <small className="text-muted">Content</small>
                  </div>
                </div>
              </div>
             
             <button className="btn btn-primary btn-lg px-4" onClick={openModal}>
                  Enroll Now
                </button>
            </div>
            <div className="col-lg-6 mt-5 mt-lg-0">
              <div className="ratio ratio-16x9">
                <img
                  src="subcourses-images/Project Manager.jpg"
                  alt="Project Management Course"
                  className="img-fluid rounded-3 shadow"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
     <div className="container">
      <div className="course-details">
        <div className="course-content">
          {/* About Course */}
          <section className="about-course">
            <h2 className="section-title">About This Course</h2>
            <p>This comprehensive Project Management program will take you from foundational concepts to advanced leadership techniques. You'll learn to initiate, plan, execute, monitor, and close projects successfully across various industries.</p>
            <p>Through real-world case studies and simulations, you'll gain experience with the same methodologies used by top companies worldwide to deliver projects on time and within budget.</p>
          </section>
         
          {/* Curriculum */}
          <section className="curriculum">
            <h2 className="section-title">Curriculum</h2>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faProjectDiagram} className="me-2" /> Module 1: Project Management Fundamentals</h3>
              <p>Master the core principles and frameworks of project management</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Project lifecycle and methodologies</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Stakeholder management</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Scope definition and requirements</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Project charters and documentation</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faChartLine} className="me-2" /> Module 2: Planning and Scheduling</h3>
              <p>Develop comprehensive project plans and realistic schedules</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Work breakdown structures</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Gantt charts and critical path method</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Resource allocation and leveling</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Risk identification and mitigation</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faBriefcase} className="me-2" /> Module 3: Leadership and Team Management</h3>
              <p>Build and lead high-performing project teams</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Team development stages</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Conflict resolution techniques</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Motivation and performance management</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Communication strategies</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faDatabase} className="me-2" /> Module 4: Budgeting and Cost Control</h3>
              <p>Manage project finances and ensure profitability</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Cost estimation techniques</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Earned value management</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Budget tracking and reporting</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Procurement and vendor management</div>
              </div>
            </div>
           
            <div className="curriculum-item">
              <h3><FontAwesomeIcon icon={faLaptopCode} className="me-2" /> Module 5: Agile and Hybrid Methodologies</h3>
              <p>Implement flexible approaches for dynamic projects</p>
              <div className="topics">
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Scrum framework</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Kanban systems</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Agile project planning</div>
                <div className="topic"><FontAwesomeIcon icon={faCheckCircle} className="me-2" /> Hybrid project approaches</div>
              </div>
            </div>
          </section>
        </div>  
       
        <div className="course-sidebar">
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faClock} />
            </div>
            <div className="info-content">
              <h4>Duration</h4>
              <p>10 Weeks (15 hrs/week)</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faCertificate} />
            </div>
            <div className="info-content">
              <h4>Level</h4>
              <p>Beginner to Intermediate</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faLaptopCode} />
            </div>
            <div className="info-content">
              <h4>Case Studies</h4>
              <p>6 Real-world Projects</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faUsers} />
            </div>
            <div className="info-content">
              <h4>Prerequisites</h4>
              <p>None (Basic business knowledge helpful)</p>
            </div>
          </div>
         
          <div className="info-item">
            <div className="info-icon">
              <FontAwesomeIcon icon={faBriefcase} />
            </div>
            <div className="info-content">
              <h4>Certification</h4>
              <p>PMI-aligned certificate upon completion</p>
            </div>
          </div>
         
          <a href="/register" className="enroll-button" style={{display: 'block', textAlign: 'center', marginTop: '2rem'}}>
            Enroll Now
          </a>
        </div>
      </div>
    </div>
    {/* MODAL */}
      {showModal && (
        <div
          className="modal d-block fade show"
          style={{ background: 'rgba(0,0,0,0.5)' }}
          onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content p-4 d-flex flex-column flex-md-row">
              <div className="w-100 w-md-50 mb-3 mb-md-0">
                <img
                  src="/img/enroll.jpg"
                  alt="Enrollment"
                  className="img-fluid h-100"
                  style={{ objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="w-100 w-md-50 ps-md-4">
                <h6 className="text-primary">Course:</h6>
                <h4 className="fw-bold">Project Management</h4>
                <form onSubmit={handleSubmit} noValidate>
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    required
                  />
                  <input
                    className="form-control mb-3"
                    type="text"
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    value={formData.mobileNumber}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />
                  <input
                    className="form-control mb-3"
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn btn-outline-dark me-2" onClick={closeModal}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
 
export default ProjectManager;